import script from "./AccountFlags.vue?vue&type=script&lang=js"
export * from "./AccountFlags.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__